export default __webpack_public_path__ + "static/media/gallery - cover_01.1ad2aea5.jpg";